<template>
  <div>
<!--    <img alt="Vue logo" src="./assets/logo.png"> -->
<!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->

	<HeaderCom />
	<router-view></router-view>
	<FooterCom />

	

  </div>
</template>

<script>
import HeaderCom from './components/HeaderCom.vue'
import FooterCom from './components/FooterCom.vue'
export default {
  name: 'App',
  components: {
	HeaderCom,
	FooterCom
  },
  created() {
      this.$store.commit('INITIALIZE_STORE');//VUEX初始化 token nickname..
	},
}
</script>

<style>
	@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard/dist/web/static/pretendard.css');

	:root {
	  --main-color: rgb(247, 148, 29);
	  --secondary-color: rgb(247, 148, 29);
	  --main-color-light: rgba(247, 148, 29, 0.1);
	  --border-radius: 26px;
	  --border-color: #f7941d;
	}

	* {
	  margin: 0;
	  padding: 0;
	  box-sizing: border-box; /* 包含边框和内边距 */
	  -webkit-tap-highlight-color: transparent; /* 去掉移动端点击灰块 */
	  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
	}

	/* 核心样式：全屏白色背景 + 深色文字 */
	html, body {
	  background-color: #ffffff;
	  /* 确保背景铺满整个屏幕 */
	  min-height: 100vh;
	  /* 重置默认边距，避免出现白边 */
	  margin: 0;
	  padding: 0;
	  /* 禁止水平溢出，防止移动端出现横向滚动条 */
	  overflow-x: hidden;
	  /* 文字设为深色，保证可读性 */
	  color: #333;
	  font-size: 17px;
	}

	/* 确保 Element UI 和表单组件也使用统一字体 */
	button, input, select, textarea, .el-button, .el-input, .el-select, .el-dropdown {
		font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
		font-size: 18px !important;
	}

	/* 全局补丁：强制提升常见文本容器字号 */
	p, span:not(.el-icon-plus):not(.el-icon-minus), li, td, th {
		font-size: 18px;
	}
	
	h1 { font-size: 2.2rem !important; }
	h2 { font-size: 1.2rem !important; }
	h3 { font-size: 1.4rem !important; }
	h4 { font-size: 1.1rem !important; }

	/* 针对个人中心等页面的特定调整 */
	.navi h2, .count-box .title, .need-box .title {
		font-size: 20px !important;
	}
	.count-box .content, .need-box .content, .menu-box li a {
		font-size: 19px !important;
	}
	.view-group-basic, .view-group-addon {
		font-size: 18px !important;
	}

	/* 全局 section header 样式 */
	.card-head, 
	.type-card > .card-head,
	.count-box .title,
	.need-box .title,
	.widget-agency-mypage-report h4,
	.process li .step,
	.register-button,
	.btn-submit,
	.height-fixed-box li strong.namecolor-blue {
	    background: var(--secondary-color) !important;
	    background-color: var(--secondary-color) !important;
	    color: #ffffff !important;
	    border-color: var(--secondary-color) !important;
	}

	/* 全局 sub-heading 样式 */
	.title-wrap h3 {
	    color: var(--main-color) !important;
	}

	/* 全局提示框样式 */
	.text-box, .help-block {
	    background-color: var(--main-color-light) !important;
	    color: var(--main-color) !important;
	}

	/* 全局蓝色文本/标签 替换为 品牌橙 */
	.color-blue, .namecolor-blue, .color-navy {
	    color: var(--main-color) !important;
	}

	/* 传奇/图例样式 */
	.agency-category-customs .type-general, 
	.type-general {
	    /* background-color: var(--main-color) !important; */
		background-color: #0055d4 !important;
	}

	/* 全局 SVG 颜色覆盖 (针对之前硬编码的蓝色) */
	svg circle[fill="#274A80"], 
	svg path[fill="#274A80"],
	svg circle[fill="#274a80"], 
	svg path[fill="#274a80"] {
	    fill: var(--main-color) !important;
	}

	/* 调整某些特定容器的间距或圆角以保持一致 */
	.type-card {
	    border-radius: var(--border-radius) !important;
	    overflow: hidden;
	}

	/* 全局分页样式优化 (Element UI) - 白色背景，黑色文字，橙色选中 */
	.el-pagination, 
	.el-pagination .el-pager li,
	.el-pagination .btn-prev, 
	.el-pagination .btn-next, 
	.el-pagination button {
	    background: #ffffff !important;
	    background-color: #ffffff !important;
	    color: #333333 !important;
	}

	.el-pagination .el-pager li.active {
	    color: var(--main-color) !important;
	    font-weight: 700 !important;
	}

	.el-pagination .el-pager li:hover {
	    color: var(--main-color) !important;
	}
</style>
